<template>
  <div>
    <div class="web-menu">
      <img
        class="web-menu-logo"
        src="@/assets/website/Logo.png"
        @click="toPage('/')"
        :style="{ visibility: websiteVisible ? 'visible' : 'hidden' }"
      />
      <!-- <div class="web-menu-menu">
        <div class="left-top-box"></div>
        <div
          v-for="(item, index) in menuList"
          :key="index"
          class="menu-item"
          :class="{
            'menu-item-active': activeIndex === index,
          }"
          :style="{ visibility: index ===0 ? (websiteVisible ? 'visible' : 'hidden') : 'visible' }"
          @click="handleClick(index)"
          @mouseenter="handelHover(index)"
          @mouseleave="
            subShow = false;
            hoverActiveIndex = null;
          "
        >
          <span class="menu-item-name">{{ item.name }}</span>
          <img
            src="@/assets/website/down.png"
            alt=""
            class="down-icon"
            v-if="item.children"
          />
          <div
            v-if="item.children && hoverActiveIndex === index && subShow"
            class="sub-menu"
            :style="{ display: hoverActiveIndex === index ? 'block' : 'none' }"
          >
            <div
              v-for="(child, childIndex) in item.children"
              :key="childIndex"
              class="sub-menu-item"
              @click="
                (e) => {
                  subClick(e, child);
                }
              "
            >
              <span class="menu-item-name">{{ child.name }}</span>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "web-menu",
  props: {
    websiteVisible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      menuList: [
        {
          name: "首页",
          icon: "el-icon-s-home",
          path: "/",
        },
        // 产品    AI数字人视频
        {
          name: "产品",
          icon: "el-icon-s-promotion",
          path: "/member",
          children: [
            {
              name: "AI数字人视频",
              icon: "el-icon-video-camera",
              path: "/member",
            },
            {
              name: "数字人智能体",
              icon: "el-icon-video-camera",
              path: "/3d",
            },
          ],
        },
        /* {
          name: "关于我们",
          icon: "el-icon-s-help",
          path: "/AboutUs",
        }, */
      ],
      activeIndex: null,
      hoverActiveIndex: null,
      subShow: false,
      mobile: false,
    };
  },

  created() {
    let list = ["/", "/member"]; // , "/AboutUs"
    let route = this.$route.path;
    if (list.includes(route)) {
      this.activeIndex = list.indexOf(route);
    }


    if (!this.websiteVisible) {
      this.menuList[0].visible = this.websiteVisible;
    }
  },
  methods: {
    handleClick(index) {
      if (this.menuList[index].children) {
        this.subShow = true;
      } else {
        this.activeIndex = index;
        this.subShow = false;
        this.$router.push(this.menuList[index].path);
      }
    },
    handelHover(index) {
      if (this.menuList[index].children) {
        this.subShow = true;
      }
      this.hoverActiveIndex = index;
    },
    subClick(e, item) {
      e.stopPropagation();
      this.subShow = false;
      this.$router.push(item.path);
    },

    toPage(path) {
      this.$router.push(path);
    },
  },
};
</script>
<style>
.web-menu {
  width: 100%;
  height: 93px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.web-menu-logo {
  width: 256px;
  height: 93px;
  cursor: pointer;
  /* margin-right: 204px; */
}
.web-menu-menu {
  width: 974px;
  height: 80px;
  display: flex;
  backdrop-filter: blur(41.67px);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0) 100%
  );
  line-height: 80px;
}
.left-top-box {
  width: 0px;
  height: 0px;
  border-top: 80px solid rgb(20, 12, 31);
  border-right: 110px solid transparent;
}
.menu-item {
  margin-right: 50px;
  line-height: 80px;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.menu-item-name {
  font-size: 18px;
  font-weight: 300;
  box-sizing: border-box;
}
.menu-item:hover {
  /* color: #bbb; */
  border-bottom: 2px solid #fff;
}
.menu-item-active {
  border-bottom: 2px solid #fff;
}
.sub-menu {
  position: absolute;
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
  top: 80px;
  left: 0;
  width: 200px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0) 100%
  );
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  display: none;
}
.web-menu-login-box {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 300;
}
.web-menu-login-btn {
  width: 120px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  border-radius: 20px;
  color: #fff;
  margin-right: 20px;
  cursor: pointer;
  border: 1px solid #fff;
}
.web-menu-login-btn:hover {
  color: rgb(20, 12, 31);
  background-color: #fff;
}
.web-menu-register {
  cursor: pointer;
}
.down-icon {
  width: 15px;
  height: 8px;
  margin-left: 4px;
}
.to-center {
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid #fff;
  padding: 8px 20px;
  border-radius: 4px;
  margin-left: 10px;
}
.web-menu-user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}
.user-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
</style>
